<template>
  <!-- 支付协议管理-新增/编辑/查看 -->
  <div>
    <a-card :title="title" style="margin: 20px">
      <template slot="extra">
        <a-button type="primary" v-if="$route.query.type !== 'view'" @click="onSave">保存
        </a-button>

        <a-button @click="OnCancel">取消</a-button>
      </template>
      <!-- 表单区域 -->
      <div class="form-box">
        <a-form-model ref="ruleForm" :model="form" :rules="rules" labelAlign="left">
          <div class="toptitle">付款人</div>

          <!-- 付款钱包 - 改为直接选择钱包 -->
          <a-form-model-item ref="name" label="付款钱包" prop="accountName">
            <a-row>
              <a-form-model-item style="border: none" prop="accountName" class="mch-style">
                <WalletChooseDialog
                    v-model="form.accountName"
                    @chooseDone="onPayerWalletChosen"
                    :isDisabled="isDisabled">
                </WalletChooseDialog>
              </a-form-model-item>
            </a-row>
          </a-form-model-item>

          <!-- 付款钱包ID -->
          <a-form-model-item style="border: none" prop="accountNo" class="mch-style" label="钱包ID">
            <WalletInfo
                v-if="form.accountNo"
                :account-no="form.accountNo"
                :account-class="payerAccountClass"
                :account-name="form.accountName">
            </WalletInfo>
          </a-form-model-item>

          <div class="toptitle">收款人</div>
          <a-form-model-item label="收款人分类" style="border: none" prop="orderType" class="mch-style">
            <a-radio-group v-model="form.orderType">
              <a-radio-button value="1">MCN</a-radio-button>
              <a-radio-button value="2">主播</a-radio-button>
              <a-radio-button value="3">厂家</a-radio-button>
              <a-radio-button value="4">其他</a-radio-button>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item label="收款账户类型" prop="oppAccountType">
            <a-radio-group v-model="form.oppAccountType" :disabled="isDisabled">
              <a-radio-button value="1">钱包</a-radio-button>
              <a-radio-button value="2">银行卡</a-radio-button>
            </a-radio-group>
          </a-form-model-item>

          <!-- 收款账户 -->
          <a-form-model-item ref="name" :label="isShowBankNUm() ? '收款账户名称' : '收款钱包名称'" prop="oppAccountName">
            <a-row>
              <a-form-model-item style="border: none" prop="oppAccountName" class="mch-style">
                <a-input :disabled="!isShowBankNUm() || isDisabled" v-if="isShowBankNUm()" v-model="form.oppAccountName"
                         :placeholder="isShowBankNUm() ? '账户户名' : '钱包名称'"></a-input>

                <WalletChooseDialog v-if="!isShowBankNUm()" v-model="form.oppAccountName" @chooseDone="onPayeeChosen" :isDisabled="isDisabled">
                </WalletChooseDialog>
              </a-form-model-item>
            </a-row>
          </a-form-model-item>

          <a-form-model-item style="border: none" prop="oppAccountNo" class="mch-style"
                             :label="isShowBankNUm() ? '银行账号/卡号' : '钱包ID'">
            <WalletInfo v-if="!isShowBankNUm()" :account-no="form.oppAccountNo" :account-class="payeeAccountClass"
                        :account-name="form.oppAccountName"></WalletInfo>
            <a-input v-if="isShowBankNUm()" v-model="form.oppAccountNo" placeholder="银行账号/卡号" :disabled="isDisabled"></a-input>
          </a-form-model-item>

          <a-form-model-item v-if="isShowBankNUm()" label="开户行/网点" prop="oppBankName">
            <bank-search :bankNo.sync="form.oppBankNo" :bankName.sync="form.oppBankName" :disabled="isDisabled"></bank-search>
          </a-form-model-item>
        </a-form-model>
      </div>

      <div class="save-dialog">
        <a-modal title="提示" :body-style="{ textAlign: 'center' }" :visible="isShowSaveDialog" :centered="true"
                 @ok="dialogHandleOk" @cancel="dialogHandleCancel">
          <p>{{ dialogMsg }}</p>
        </a-modal>
      </div>
    </a-card>
  </div>
</template>

<script>
// 移除 MchChooseDialog 导入
import WalletChooseDialog from "@/view/components/ChooseDialog/WalletChooseDialog.vue";
import WalletInfo from "@/view/components/WalletInfo.vue";
import BankChoose from "@/view/components/BankChoose.vue";
import {generateRandomString} from "@/utils/commonMethods";
import BankSearch from "@/view/components/BankSearch.vue";

export default {
  name: "commonAddPayment",
  components: {
    BankSearch,
    BankChoose,
    WalletChooseDialog,
    WalletInfo,
  },
  data() {
    // 初始表单数据放在一个函数中，方便重置
    const initForm = () => ({
      // 所属机构
      departmentId: "",
      //渠道编号
      channelNo: "",
      // 应用编号
      appNo: "",
      // 付款户名
      accountName: "",
      // 付款账号
      accountNo: "",
      // 订单类型
      orderType: "4",
      //收款账户类型
      oppAccountType: "2",
      // 收款账号
      oppAccountNo: "",
      // 收款户名
      oppAccountName: "",
      // 收款行号
      oppBankNo: undefined,
      // 收款行名
      oppBankName: undefined,
      // 收款行名（协议编号）
      fileNo: undefined,
    });

    const rules = {
      accountName: [
        {required: true, message: "请选择付款钱包", trigger: "change"},
      ],
      accountNo: [
        {required: true, message: "请选择付款钱包", trigger: "change"},
      ],
      oppAccountType: [
        {required: true, message: "请选择收款账户类型", trigger: "change"},
      ],
      oppAccountName: [
        {required: true, message: "请填写收款户名", trigger: "blur"},
      ],
      oppAccountNo: [
        {
          required: true, validator: (rule, value, callback) => {
            const cardRegex = new RegExp(/^[a-zA-Z0-9]{5,}$/)
            if (!cardRegex.test(value)) {
              callback(new Error('银行账号/卡号输入有误'))
            }
            callback()
          }, trigger: "blur"
        },
      ],
      oppBankNo: [
        {
          required: true, validator: (rule, value, callback) => {
            const cardRegex = new RegExp(/^[a-zA-Z0-9]{5,}$/)
            if (!cardRegex.test(value)) {
              this.form.oppBankNo = ''
              callback(new Error('开户行号输入有误'))
            }
            callback()
          }, trigger: "blur"
        },
      ],
      oppBankName: [
        {required: true, message: "请填写银行卡号", trigger: "blur"},
      ],
      fileNo: [{required: true, message: "", trigger: "change"}],
    };

    return {
      // 表单对象
      form: initForm(),
      // 表单校验规则
      rules,
      payerAccountClass: undefined, // 付款方账户类型
      treeData: [],
      // 列表弹框
      isShowTableDialog: false,
      //选择按钮类型
      selectType: "",
      // 保存和取消弹框
      isShowSaveDialog: false,
      // 收款人账号类型
      payeeAccountClass: undefined,
      saveOrCancel: "",
      isShowBankChoose: false,
    };
  },
  computed: {
    title: function () {
      if (this.$route.query.type == "add") {
        return "支付协议管理>新增";
      } else if (this.$route.query.type == "edit") {
        return "支付协议管理>编辑";
      } else if (this.$route.query.type == "view") {
        return "支付协议管理>查看";
      } else {
        return "";
      }
    },
    isView() {
      return function () {
        return this.$route.query.type == "view";
      };
    },
    isDisabled() {
      if (this.$route.query.type === "add") return false
      if (this.$route.query.type === "edit" && this.form.checkStatus === '1') return true
      return false
    },
    // 是否显示表单最后三项
    isShowBankNUm() {
      return function () {
        return this.form.oppAccountType == "2";
      };
    },
    dialogMsg: function () {
      if (this.saveOrCancel == "save") {
        return "是否确认添加？";
      } else {
        return "是否取消新增？取消后该页面信息将不会被保存";
      }
    },
  },
  watch: {
    // 监听路由变化，当路由参数变化时重新加载数据
    '$route.query': {
      immediate: true, // 立即执行一次
      handler(newQuery, oldQuery) {
        if (newQuery.type && newQuery.id) {
          // 只有当type和id都变化时才重新加载
          if (newQuery.type !== oldQuery?.type || newQuery.id !== oldQuery?.id) {
            this.initPageData();
          }
        } else if (newQuery.type === 'add') {
          // 如果是新增页面，重置表单
          this.resetPageData();
        }
      }
    }
  },
  created() {
    this.initPageData();
  },
  mounted() {
    if (this.$route.query.type != 'add') {
      sessionStorage.setItem('msgInfo', true)
    }
  },
  methods: {
    // 初始化页面数据
    initPageData() {
      // 重置数据
      this.resetFormData();

      this.form.departmentId = Number(this.$session.getItem("companyId"));
      // 获取机构列表
      this.getCustList();

      if (this.$route.query.type == "add") {
        // 新增页面，不需要额外操作
      } else if (this.$route.query.type == "edit" || this.$route.query.type == "view") {
        // 编辑或查看-进入页面调用详情接口回显数据
        if (this.$route.query.id) {
          this.viewProtocol();
        }
      }
    },

    // 重置页面数据
    resetPageData() {
      this.resetFormData();
      this.payerAccountClass = undefined;
      this.payeeAccountClass = undefined;
      this.isShowSaveDialog = false;
      this.saveOrCancel = "";
    },

    // 重置表单数据
    resetFormData() {
      // 重置表单数据到初始状态
      const initForm = {
        departmentId: Number(this.$session.getItem("companyId")),
        channelNo: "",
        appNo: "",
        accountName: "",
        accountNo: "",
        orderType: "4",
        oppAccountType: "2",
        oppAccountNo: "",
        oppAccountName: "",
        oppBankNo: undefined,
        oppBankName: undefined,
        fileNo: undefined,
      };

      this.form = Object.assign({}, initForm);

      // 重置表单验证
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate();
      }
    },

    // 付款钱包选择完成
    onPayerWalletChosen(wallet) {
      this.form.accountName = wallet.accountName;
      this.form.accountNo = wallet.accountNo;
      this.payerAccountClass = wallet.accountClass;
      // 这里可以根据需要设置其他字段
      this.form.departmentId = wallet.departmentId || this.form.departmentId;

      // 生成协议编号（如果需要）
      if (!this.form.fileNo) {
        this.form.fileNo = "STZF" + "-" + wallet.accountNo + "_" + generateRandomString(4);
      }
    },

    // 收款钱包选择完成
    onPayeeChosen(wallet) {
      this.form.oppAccountName = wallet.accountName;
      this.form.oppAccountNo = wallet.accountNo;
      this.payeeAccountClass = wallet.accountClass;
    },

    changeBank(obj) {
      this.form.oppBankNo = obj.value
      this.form.oppBankName = obj['option'].componentOptions.children[0].text
      this.isShowBankChoose = false
      this.$nextTick(() => {
        this.$refs.ruleForm.validateField('oppBankName', 'oppBankNo');
      });
    },

    // 获取所属机构下拉框数据
    async getCustList() {
      let data = {
        username: this.$session.getItem("username"),
      };
      let res = await this.api.agencyList(data);
      let trees = [];
      trees.push(res.data);
      this.treeData = this.getResettingTrees(trees);
    },

    //重构树形结构方法
    getResettingTrees(trees) {
      if (trees.length == 0) {
        return [];
      }
      let res = [];
      trees.forEach((tree) => {
        res.push({
          title: tree.coreDepartment.name,
          value: tree.coreDepartment.id,
          key: tree.coreDepartment.id,
          children:
              tree.children && tree.children.length > 0
                  ? this.getResettingTrees(tree.children)
                  : [],
        });
      });
      return res;
    },

    // 保存按钮
    onSave() {
      this.saveOrCancel = "save";
      // 打开弹框
      this.isShowSaveDialog = true;
    },

    // 取消按钮
    OnCancel() {
      if (this.$route.query.type == "view") {
        this.$router.back(-1);
      } else {
        this.saveOrCancel = "cancel";
        this.isShowSaveDialog = true;
      }
    },

    // 保存和取消弹框里的确定事件
    dialogHandleOk() {
      // 关闭弹框
      this.isShowSaveDialog = false;

      if (this.form.oppAccountType === "1") {
        this.form.oppBankNo = "313338707013"
        this.form.oppBankName = "浙江稠州商业银行"
      }

      if (this.saveOrCancel == "save") {
        //校验
        this.onSubmit();
      } else {
        // 跳转到列表页
        this.$router.push('/orders/PaymentProtocolManage');
      }
    },

    // 保存和取消弹框里的取消事件
    dialogHandleCancel() {
      this.isShowSaveDialog = false;
    },

    // 新增或者编辑接口
    async addAndEditProtocol() {
      let data = JSON.parse(JSON.stringify(this.form));
      if (this.$route.query.type == "add") {
        let res1 = await this.api.addProtocolApi(data);
        if (res1.code == 200) {
          // 成功之后跳转到列表页
          this.$router.push({
            path: '/orders/PaymentProtocolManage',
            query: {
              fromAddPage: true
            }
          });
          this.$message.success(res1.info);
        } else {
          return this.$message.error(res1.info);
        }
      } else if (this.$route.query.type == "edit") {
        data.synch = '0'
        let res2 = await this.api.updateProtocolApi(data);
        if (res2.code == 200) {
          // 成功之后跳转到列表页
          this.$router.push({
            path: '/orders/PaymentProtocolManage',
            query: {
              fromEditPage: true
            }
          });
          this.$message.success(res2.info);
        } else {
          return this.$message.error(res2.info);
        }
      }
    },

    // 查看详情接口
    async viewProtocol() {
      let data = {};
      data.id = this.$route.query.id;
      let res = await this.api.viewProtocolApi(data);
      if (res.code == 200) {
        this.form = res.data;
      } else {
        return this.$message.error(res.info);
      }
    },

    onSubmit() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          // 校验成功调用保存或者编辑接口
          await this.addAndEditProtocol();
        } else {
          console.log("error submit!!");
        }
      });
    },

    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.form-box {
  .toptitle {
    font-weight: 600;
    margin: 10px 0;
  }

  /deep/ .ant-select-selection--single {
    width: 200px;
  }

  /deep/ .ant-form-item {
    display: flex;
    margin-bottom: 0;

    .mch-style {
      .ant-form-item-control-wrapper {
        border: none;
        padding: 5px 0 0 0;
        margin-right: 15px;
      }
    }

    .ant-form-item-label {
      width: 260px;
      background-color: rgba(242, 242, 242, 1);
      padding-left: 20px;
      display: flex;
      align-items: center;
    }

    .ant-form-item-control-wrapper {
      flex: 1;
      border: 1px solid rgba(242, 242, 242, 1);
      padding: 5px 40px;

      .ant-form-item-children {
        display: flex;
      }

      .ant-input,
      .el-input__inner {
        max-width: 200px;
      }

      .ant-select {
        width: 200px;
      }

      textarea {
        resize: none;
        width: 610px !important;
        height: 137px;
      }
    }
  }
}
</style>